import { getCountryByIP } from "../api/GetIPAPI";
import { useDispatch } from "react-redux";
import { setCountry, setIsEuro } from "../store/countrySice";

const europeanCountries = ["GB", "DE", "FR"];

export const getLocation = async (dispatch) => {
  try {
    const res = await getCountryByIP();
    var data = res.data.data;
    if (data) {
      isEuropeanCountries(dispatch, data.country);
      dispatch(setCountry(data.country));
    }
  } catch (error) {
    console.error("Failed to get IP location:", error);
  }
};

export const isEuropeanCountries = (dispatch, country_code) => {
  let isEuro = europeanCountries.includes(country_code?.toUpperCase());
  if (isEuro) return dispatch(setIsEuro(isEuro));
};
